import React from 'react';
import type { CaraWorkspaceFieldsFragment } from '~/api/graphql';
import { mapWorkspaceAttachableArtifacts } from '~/components/workspaces/lib/pdf-attachment-export';

/** Shared workspace file/artifact sources for PDF attachment export UIs. */
export function useWorkspaceAttachableArtifacts(workspace: CaraWorkspaceFieldsFragment) {
  const workspaceMessageFiles = React.useMemo(
    () => (workspace.messages ?? []).flatMap((m) => m.files),
    [workspace.messages]
  );

  const workspaceArtifacts = React.useMemo(
    () => mapWorkspaceAttachableArtifacts(workspace.artifacts),
    [workspace.artifacts]
  );

  const workspaceFiles = React.useMemo(
    () =>
      (workspace.files ?? []).map((f) => ({
        id: f.id,
        name: f.name,
        mimeType: f.mimeType
      })),
    [workspace.files]
  );

  return { workspaceFiles, workspaceMessageFiles, workspaceArtifacts };
}
